import React from "react";
import { Ticket } from "../../../../../models/Ticket";

interface IProps {
  pass: Ticket;
  title: string;
}

const DetailsHeader: React.FC<IProps> = ({ pass, title }) => {
  return (
    <div className="ticket-details__header">
      <div className="ticket-details__name-section">
        <span className="body-text-small text-color-light-gray">{title}</span>
        <h5>{pass.name}</h5>
      </div>
    </div>
  );
};

export default DetailsHeader;
